// Generated by purs version 0.15.16
import * as API_Search from "../API.Search/index.js";
import * as Concur_Core_LiftWidget from "../Concur.Core.LiftWidget/index.js";
import * as Concur_Core_Patterns from "../Concur.Core.Patterns/index.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Concur_React_DOM from "../Concur.React.DOM/index.js";
import * as Concur_React_Props from "../Concur.React.Props/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Shape from "../GraphQL.Shape/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Translate from "../Translate/index.js";
import * as Widgets_BetterSelect from "../Widgets.BetterSelect/index.js";
import * as Widgets_Modal from "../Widgets.Modal/index.js";
var inputIsSymbol = {
    reflectSymbol: function () {
        return "input";
    }
};
var encRNTY = /* #__PURE__ */ GraphQL_Type.encRNTY(Data_Argonaut_Encode_Class.encodeJsonJString);
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var formsIsSymbol = {
    reflectSymbol: function () {
        return "forms";
    }
};
var rlhsCons = /* #__PURE__ */ GraphQL_Shape.rlhsCons(GraphQL_Shape.rlhsNil);
var buildMutation = /* #__PURE__ */ GraphQL_Query.buildMutation(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ GraphQL_Query.rltvCons(GraphQL_Query.rltvNil)(inputIsSymbol)(/* #__PURE__ */ GraphQL_Type.hqtArray(/* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "UpdateFormInput";
    }
})))(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ GraphQL_Type.encRNTY(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encRNTY)(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonJString))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(encRNTY))(Data_Argonaut_Encode_Class.gEncodeJsonNil)({
    reflectSymbol: function () {
        return "teacher_id";
    }
})())({
    reflectSymbol: function () {
        return "semester";
    }
})())({
    reflectSymbol: function () {
        return "form_id";
    }
})())())))()())(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(GraphQL_Query.rltvfNil)(inputIsSymbol)())())(/* #__PURE__ */ GraphQL_Query.jsonQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ GraphQL_Type.decRNTY(Data_Argonaut_Decode_Class.decodeJsonString)))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(idIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(formsIsSymbol)()())())(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons(formsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ rlhsCons(idIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())()));
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var loopState = /* #__PURE__ */ Concur_Core_Patterns.loopState(Concur_Core_Types.monadWidget);
var multiAlternativeWidget = /* #__PURE__ */ Concur_Core_Types.multiAlternativeWidget(Data_Monoid.monoidArray);
var div = /* #__PURE__ */ Concur_React_DOM.div(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var h1 = /* #__PURE__ */ Concur_React_DOM.h1(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var text = /* #__PURE__ */ Concur_React_DOM.text(Concur_Core_LiftWidget.liftWidgetWidget);
var map1 = /* #__PURE__ */ Data_Functor.map(Concur_Core_Types.functorWidget);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorFn);
var button = /* #__PURE__ */ Concur_React_DOM.button(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Concur_React_Props.functorProps);
var map3 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var bind = /* #__PURE__ */ Control_Bind.bind(Concur_Core_Types.bindWidget);
var div$prime = /* #__PURE__ */ Concur_React_DOM["div$prime"](multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var pure = /* #__PURE__ */ Control_Applicative.pure(Concur_Core_Types.applicativeWidget);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var updateFormsMutation = function (selection) {
    return function (forms) {
        var teacherInput = function (teacher) {
            return function (f) {
                return GraphQL_Type.namedType({
                    form_id: f.id,
                    semester: Data_Maybe.Nothing.value,
                    teacher_id: new Data_Maybe.Just(teacher.id)
                });
            };
        };
        var semesterInput = function (sem) {
            return function (f) {
                return GraphQL_Type.namedType({
                    form_id: f.id,
                    semester: new Data_Maybe.Just(sem.semester),
                    teacher_id: Data_Maybe.Nothing.value
                });
            };
        };
        if (selection instanceof Data_Either.Left) {
            return GraphQL_Query.nameQuery("MassUpdateSemesters")(buildMutation("updateForms")({
                input: map(semesterInput(selection.value0))(forms)
            }));
        };
        if (selection instanceof Data_Either.Right) {
            return GraphQL_Query.nameQuery("MassUpdateTeachers")(buildMutation("updateForms")({
                input: map(teacherInput(selection.value0))(forms)
            }));
        };
        throw new Error("Failed pattern match at Widgets.UpdateForm (line 67, column 39 - line 71, column 52): " + [ selection.constructor.name ]);
    };
};
var formUpdateSelect = function (state$prime) {
    return loopState(state$prime)(function (state) {
        return div([ Concur_React_Props.className("modal-col modal-narrow") ])([ h1([ Concur_React_Props.className("modal-heading") ])([ text(state.header) ]), map1(map2(Data_Either.Left.create)(function (v) {
            return {
                forms: state.forms,
                header: state.header,
                select: v
            };
        }))(Widgets_BetterSelect.selectWidget(state.select)), button([ Concur_React_Props.className("btn btn-primary"), Concur_React_Props.disabled(Data_Maybe.isNothing(Widgets_BetterSelect.selectedItem(state.select))), voidRight(new Data_Either.Right(state))(Concur_React_Props.onClick) ])([ text(Translate.lookupTranslation("save")) ]) ]);
    });
};
var formUpdateModal = function (state) {
    var finalSelection = function (v) {
        if (v instanceof Widgets_Modal.ModalClosed) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Widgets_Modal.ModalReturned) {
            return map3(function (v1) {
                return v1.value;
            })(Widgets_BetterSelect.selectedItem(v.value0.select));
        };
        throw new Error("Failed pattern match at Widgets.UpdateForm (line 94, column 5 - line 94, column 65): " + [ v.constructor.name ]);
    };
    return bind(map1(finalSelection)(Widgets_Modal.modalWidget(div$prime([  ]))(formUpdateSelect(state))))(function (selected) {
        return pure(selected);
    });
};
var semesterUpdateModal = function (forms) {
    var count = length(forms);
    return formUpdateModal({
        forms: forms,
        header: Translate.lookupTranslation("update-semester-for") + (" " + (show(count) + (" " + Translate.lookupTranslation("forms")))),
        select: Widgets_BetterSelect["initSelect$prime"]("semester")(API_Search.semesterSearchAff)({
            deselectLabel: Widgets_BetterSelect.defSelectConfig.deselectLabel,
            editable: Widgets_BetterSelect.defSelectConfig.editable,
            placeholder: new Data_Maybe.Just(Translate.lookupTranslation("search-semester")),
            allowDeselect: false
        })
    });
};
var teacherUpdateModal = function (forms) {
    var count = length(forms);
    return formUpdateModal({
        forms: forms,
        header: Translate.lookupTranslation("update-teacher-for") + (" " + (show(count) + (" " + Translate.lookupTranslation("forms")))),
        select: Widgets_BetterSelect["initSelect$prime"]("teacher")(API_Search.teacherSearchAff)({
            deselectLabel: Widgets_BetterSelect.defSelectConfig.deselectLabel,
            editable: Widgets_BetterSelect.defSelectConfig.editable,
            placeholder: new Data_Maybe.Just(Translate.lookupTranslation("search-teacher")),
            allowDeselect: false
        })
    });
};
export {
    semesterUpdateModal,
    teacherUpdateModal,
    updateFormsMutation,
    formUpdateModal,
    formUpdateSelect
};
//# sourceMappingURL=index.js.map
